import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { encode } from '../jsonEncode';
import { BaseApiUrl, LoginApiUrl, UIClientTypes } from '@tradingblock/types';
import { LogoutTokenUrl } from '../constants';
import { verify } from '../utilities/JwtUtilities';
import { checkToken } from './checkToken';

function isString(x) {
  return typeof x === 'string';
}

export function TryLogin(values, options) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var host, loginUrl, headers;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            host = options.host || '';
            loginUrl = host + (options.subdirectory ? options.subdirectory : '') + LoginApiUrl(options.subroot);
            headers = {
              'Content-Type': 'application/json'
            };
            _context.next = 5;
            return fetch(loginUrl, {
              method: 'POST',
              body: JSON.stringify({
                encoded: encode(values)
              }),
              headers: headers
            }).then(function (res) {
              return res.json();
            }).then(function (json) {
              return json;
            });

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
var httpOptions = {
  headers: {
    Accept: 'application/json'
  }
};
export var auth = function auth(api) {
  return {
    logout: function logout() {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", api.authenticated().post(LogoutTokenUrl, {}, httpOptions));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    },
    checkToken: checkToken(api)
  };
};

var tryVerify = function tryVerify(publicKey, token) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var decoded, jwtValues;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return verify(publicKey, token, {
              clientType: [UIClientTypes.dashboard, UIClientTypes.application],
              algorithms: ['RS256'],
              ignoreExpiration: false
            });

          case 3:
            decoded = _context3.sent;

            if (!(!decoded || isString(decoded))) {
              _context3.next = 9;
              break;
            }

            console.warn('jwt response was invalid, an object was expected', decoded);
            return _context3.abrupt("return", null);

          case 9:
            jwtValues = decoded;
            return _context3.abrupt("return", {
              value: token,
              decoded: jwtValues
            });

          case 11:
            _context3.next = 17;
            break;

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](0);
            console.warn('token verification failed:', _context3.t0);
            return _context3.abrupt("return", null);

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 13]]);
  }));
};

export var verifyToken = function verifyToken(id_token, uiApi) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var pubKey;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetch("".concat(BaseApiUrl, "/publickey")).then(function (res) {
              return res.json();
            });

          case 2:
            pubKey = _context4.sent;
            _context4.next = 5;
            return tryVerify(pubKey.key, id_token);

          case 5:
            return _context4.abrupt("return", _context4.sent);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};